module.exports = __webpack_public_path__ + "static/icon-campaign-2-c0cfec2cb60e545a91c9132208e67537.png";